const indicatorState = ref({
  loading: false,
  tip: ''
})


const timeout = 10 * 3000
let timer: number | null = null
let count = 0
function open(tip: string = '加载中...', _timeout: number = timeout) {
  count++
  indicatorState.value.tip = tip
  if(indicatorState.value.loading === false) {
    indicatorState.value.loading = true
  }
  if(timer) {
    clearTimeout(timer)
  }
  timer = setTimeout(
    () => {
      count = 0
      indicatorState.value.loading = false
      timer = null
    },
    _timeout
  )
}

function close() {
  if(count === 0) return
  if(--count === 0) {
    indicatorState.value.loading = false
    if(timer) {
      clearTimeout(timer)
      timer = null
    }
  }
}

export function useIndicator() {
  return {
    open,
    close
  }
}

export function useIndicatorState() {
  return readonly(indicatorState)
}